import {
    ChangeDetectorRef,
    Component,
    HostListener,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { DisplayOptions, IOptionalSummaryList } from '../../../shared/interfaces/display-options';
import { NoDataActionType } from '../../../shared/interfaces/no-data';
import { CustomDashboardsService } from 'app/modules/my-limegear/services/my-limegear.service';
import { ComponentsOutletDirectiveService } from 'app/modules/my-limegear/services/component-outlet-directive.service';
import { CustomDashboardsOutletDirective } from 'app/modules/my-limegear/my-limegear-outlet.directive';
import { IPageHeadline } from 'app/modules/shared/classes/page-title-parameters';

@Component({
    selector: 'app-performance',
    templateUrl: './performance.component.html',
    styleUrls: ['./performance.component.scss'],
})
export class PerformanceComponent implements OnInit {
    pageTitle = 'Performance At a Glance';
    displayOptions: DisplayOptions[];
    hFilterJSON = '';
    smallCardIdArray: Array<string>;
    largeCardIdArray: Array<string>;
    dashboard = 'performance';
    pageHeadline: IPageHeadline;
    extraParameters: IOptionalSummaryList[];

    constructor(
        private cd: ChangeDetectorRef,
        private customDashboardsService: CustomDashboardsService,
        private componentsOutletDirectiveService: ComponentsOutletDirectiveService
    ) {}

    @ViewChildren(CustomDashboardsOutletDirective)
    dashboardOutlet: QueryList<CustomDashboardsOutletDirective>;

    ngOnInit() {
        this.extraParameters = [{ title: 'compareto', value: 'Previous Period' }];
        this.pageHeadline = {
            module: 'performance',
            moduleIcon: 'fa-heartbeat',
            pageTitle: 'Performance At a Glance',
            linkArray: [
                {
                    moduleLink: 'performance',
                    linkTitle: 'Performance Home',
                    showLink: true,
                    isHome: true,
                },
            ],
        };
        this.customDashboardsService.destroyCharts();
        this.customDashboardsService.detectChange(
            '',
            [],
            false,
            false,
            NoDataActionType.pageStart,
            this.dashboard
        );
        this.smallCardIdArray = [
            'totalHeadcount',
            'totalProducers',
            'totalOpsSupport',
            'topProducersByscore',
            'bottomTenuredProducers',
        ];

        this.largeCardIdArray = ['performance-projections-actual', 'performance-kpi'];
        this.updateComponent();
    }

    updateComponent() {
        this.componentsOutletDirectiveService.detectViewChanges(this.cd);
        this.componentsOutletDirectiveService.loadContents(this.dashboardOutlet);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.customDashboardsService.reCreateExistingCharts();
    }

    applyNewFilters(event: string) {
        this.customDashboardsService.destroyCharts();
        this.hFilterJSON = event;
        this.updateComponent();
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            true,
            false,
            NoDataActionType.filter,
            this.dashboard
        );
    }

    applyDisplayOptions(event: DisplayOptions[]) {
        this.customDashboardsService.destroyCharts();
        this.displayOptions = event;
        this.updateComponent();
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            false,
            true,
            NoDataActionType.filter,
            this.dashboard
        );
    }

    ngOnDestroy() {
        this.customDashboardsService.unsubscribeFilters();
        this.customDashboardsService.destroyCharts();
    }
}
